const VectorHouse = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 80 80"
        preserveAspectRatio="xMidYMax meet"
    >
        <path d="M40,10 L10,40 L10,70 L70,70 L70,40 Z" fill="#CD853F" />
        <path d="M40,10 L50,20 L30,20 Z" fill="#A0522D" />
        <rect x="30" y="50" width="20" height="20" fill="#8B4513" />
    </svg>
);

export default VectorHouse;
